import { useAppSelector } from 'application/providers/StoreProvider';
import { selectStreamLibraryId } from 'application/store';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountCompanyStreamLibraryId = () => {
  const selectors = useAccountSelectors();

  const streamLibraryId = useAppSelector(selectors.selectCompanyStreamLibraryId);
  const streamLibraryIdFallback = useAppSelector(selectStreamLibraryId);

  return streamLibraryId || streamLibraryIdFallback;
};
